export default {
  local: '中文',
  en: 'English',
  zh: '中文',
  ok: '确定',
  cancel: '取消',
  survivalDay: '存活日',
  cellCount: '细胞数',
  externalEnvironment: '外部环境',
  reproductive: '繁殖性',
  adaptability: '适应性',
  survivability: '生存性',
  geneticNumber: '遗传编号：',
  naturallyReproductive: '天生繁殖性：',
  naturallyAdaptable: '天生适应性：',
  naturalSurvivability: '天生生存性：',
  lifeCycle: '生命周期',
  reproduce: '繁殖',
  evolution: '进化',
  mutations: '变异',
  dormant: '休眠',
  apoptosis: '凋亡',
  genetic: '遗传',
  worldData: '世界数据',
  cellInformation: '细胞资料',
  cellData: '细胞数据',
  howToPlay: '玩法说明',
  loading1: '获得遗传信息中..',
  loading2: '读取世界编号<{{id}}>资料中..',
  loading3: '读取细胞编号<{{id}}>资料中..',
  whatIsCellEvolution: '细胞进化是第一款基于区块链的去中心化的沙盒经营策略游戏，所有的玩家扮演一个细胞族群。在这个族群里，我们需要平衡我们 总体的适应性，生存性与繁殖性。当我们的细胞族群的方向失衡，我们整体将会进化失败。这不仅仅是个游戏，也是个真正的社会 群体实验。你在这里扮演了一个原始细胞，而无数个你将会决定我们共同的命运。接下来，开启的进化之旅！',
  whatIsSurvivalDays: '存活日代表着游戏内已经存活的天数,尽可能多的存活可以拿到更高分数。',
  whatIsCellCount: '细胞数代表着你现有的细胞数量,尽可能多的培育细胞可以拿到更高分数。',
  whatIsExternalEnvironment: '外部环境会随着存活日增加而增加,高危的环境会对生命周期造成威胁。',
  whatIsReproduction: '繁殖性决定每次繁殖的数量。',

  whatIsAdaptability: '适应性决定了变异的成功率。',
  whatIsSurvivability: '生存性决定了细胞抗击外部环境的抵抗力。',
  whatIsLifeCycle: '生命周期决定了细胞的生存日,在生命周期结束前尝试休眠吧',
  whatIsMultiplication: '繁殖可以增加细胞数量。',
  whatIsEvolution: '进化可以在特定条件下增强繁殖性适应性与生存性。',
  whatIsMutation: '变异也可以在特定条件下增强繁殖性适应性与生存性,据说变异有三种模式。',
  whatIsDormancy: '休眠可以恢复生命周期,恢复数量与生存性和外部环境有关。 尽可能的运用自己的策略来发展出独一无二的细胞,总计逾千种称号会体现在游戏中。',
  whatIsApoptosis: "细胞凋亡是生物学上的术语，在自然界中也是非常重要的发现。有些细胞牺牲是有利于有机体的维持和更新，他们完成自己的使命后，自己悄悄退出。在这里我们通过这个功能给了世界修补者更多发挥的空间。当你选择凋亡的时候，细胞的生命周期会即刻归零，繁殖性，适应性以及生存性中最高的属性会有部分融合进世界dna。牺牲自我，成就世界。",
  whatIsGenetic: "遗传细胞可以在开始的时候，遗传一定世界dna的属性作为初始属性，有几率遗传到比较好的属性，也有几率遗传下来的属性较低。不过如果想要冲击高分的玩家，可以尽可能的遗传到较高的三个初始属性，作为开局。而想要修补世界的玩家，则可以针对性的选择遗传开局。这样也增加了世界与个体细胞的联动，激励大家更多的去融合进世界，冲击更高的世界分数,这样也对自己后面的游戏更容易争取初期优势。",
  whatIsWorldData: '世界数据可以获得当前族群的所有数据',
  whatIsCellData: '细胞资料可以任意读取之前进行DNA融合的细胞资料。',
  BeautyOfTheUniverse: '宇宙之美',
  BeautyOfTheUniverse1: '浩瀚的宇宙中有无数的世界, 能否进化到你想要的世界需要团队精神与合作意识。',
  BeautyOfTheUniverse2: '各种宇宙的意识形态以及达成的条件都有所不同,这是一个多元化的世界。虫族世界需要充沛的细胞, 而精神世界则不会有过多的细胞存在。',
  BeautyOfTheUniverse3: '每个玩家都有5^99的选择，也是1.57e+69次可能, 无数玩家汇聚成世界,无数次的偶然,几率,变异,凋亡, 这是真正的从1到无限可能,经过无数次的变化, 最终世界收束成它最后的模样。我认为这是一种数学之美,也是真正的科幻之美!',
  whatIsinfoTitle: '细胞进化需要Ethereum钱包的支持，这样可以进行DNA融合，体验到更多游戏性。',
  metamaskLink: 'MetaMask 网页下载地址',
  note: '小记:',
  noteContent: '设计这款游戏的初衷就是想要做出一款真正的游戏,不是区块链的发币，博傻等传统意义上的游戏，我认为区块链是一种工具,让游戏过程,数据更加高效透明的情况下,通过自己的链上逻辑,拥有自己的生态逻辑,可以让游戏过程更加独具游戏性。接着我发现跟传统意义不一样，如果真的有一个游戏可以让所有人参与进生态,无数个体决定世界的走向，那么这就不是一个单机经营，一个简单的积分榜，而是一个真正的匿名群体游戏，有追逐高分的玩家，有群体合作的玩家，有新手，也有高玩，有创造者，也有修补者，各色各样的个体构建一个真正的区块链游戏, Cell Evolution. 希望你们喜欢。 -Ling',
  successfullReproduction: '繁殖成功',
  successfullEvolutionary: '进化成功',
  EvolutionFailure: '进化失败',
  whyEvolutionFailure: '需要属性平衡才能进化',
  successfullMutations: '变异成功',
  mutationsFailure: '变异失败',
  whyMutationsFailure: '至少需要1个细胞才能变异',
  successfullDormant: '休眠成功',
  dormantFailure: '休眠失败',
  whyDormantFailure1: '至少需要1个细胞才能休眠',
  whyDormantFailure2: '数据错误,作弊行为或者网络卡顿～',
  successfullGenetic: '遗传成功',
  geneticFailure: '遗传失败',
  whyGeneticFailure1: '只能在存活日为1的时候遗传',
  whyGeneticFailure2: '未获取到钱包信息',
  whyGeneticFailure3: '请将metamask的chainId切换为',
  whyGeneticFailure4: '钱包异常',

  geneticFailureContent: '只能在存活日为1的时候遗传',
  afterApoptosis: '凋亡后将会直接结束游戏，是否确定凋亡?',
  fusionDNA: '融合DNA中...',
  fusionDNASuccess: '融合DNA成功',
  fusedCellID: '融合的细胞ID为 ',
  uploadFailure: '上传失败',
  whyFusedCellFailure1: '未获取到钱包信息',
  whyFusedCellFailure2: '请将metamask的chainId切换为 ',
  whyFusedCellFailure3: '钱包异常',
  enterTheWordID: '输入想要读取世界的ID ',
  worldID: '世界ID',
  enterCellId: '输入想要读取细胞的ID ',
  cellId: '细胞ID',
  worldInformation: '读取世界信息成功',
  number: '编号',
  worldCellCount: '世界细胞数: ',
  worldAdaptability: '世界适应性: ',
  worldSurvivability: '世界生存性: ',
  worldReproductiveness: '世界繁殖性: ',
  worldExternalEnvironmen: '世界外部环境: ',
  worldSurvivalDay: '世界存活日: ',
  overallScore: '总体得分: ',
  worldTitle: '世界称号: ',
  groupHasBeenDestroyed: `已经有{{number}}个族群毁灭，请注意族群的平衡发展,一味的追逐高分也许并不能带来胜利。-Ling`,
  finalEvaluation: '最终评价：',
  finalScore: '最终得分：',
  cellCreator: '细胞创造者：',
  ethnicGroup: '所属族群：',
  cellInformationSuccessfully: '读取细胞信息成功',
  readWorldDataFailed: '读取世界数据失败',
  worldAndcell: '世界数据和细胞资料',
  details: '详情',
  gameOver: '游戏结束',
  isUploadDNA: '是否上传DNA，融合进族群？',
  veryLittle: '极少',
  minority: '少数',
  less: '较少',
  medium: '中等数量',
  more: '较多',
  many: '很多',
  superMulti: '超级多',
  countlessMillions: '数以亿计',
  supercell: '超级细胞',
  eukaryoticCells: '真核细胞',
  prokaryoticCells: '原核细胞',
  paleonuclearCells: '古核细胞',
  singleCell: '单细胞',
  zombie: '僵尸',
  zombieSubspecies: '僵尸亚种',
  normal: '正常',
  superbEnvironmentalResistance: '超强环境抵抗',
  strongEnvironmentalResistance: '较强环境抵抗',
  weakerEnvironmentalResistance: '较弱环境抵抗',
  weakEnvironmentalResistance: '弱环境抵抗',
  superbAdaptation: '超强适应',
  superSurvival: '超强生存',
  superbBreeding: '超强繁殖',
  SuccessfulOperation: '操作成功',
  OperationFailed: '操作失败'
}
